import { Link, useLocation, useHistory } from "react-router-dom";
import { MenuDropdown, MenuDetailedSearch, MenuSimpleSearch } from '../components';
import { Navbar, Nav, Alert } from "react-bootstrap";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { isLoggedUser, getLoggedUserToken } from "../redux/selectors";
import ShoppingCartConsumer from './ShoppingCartMenuComponent';
import queryString from 'query-string';

const Menu = ({ hideDetailedSearch, hideAlerts, loggedUser, userToken }) => {
    const menuDDs = [
        ['Marine', 'marine', process.env.REACT_APP_MARINE_ID],
        ['Lawn & Garden', 'garden', process.env.REACT_APP_GARDEN_ID],
        ['Power Sports', 'power-sports', process.env.REACT_APP_POWERSPORTS_ID]
    ];
    const [ShowAlert, setShowAlert] = useState(false);
    const location = useLocation();
    const history = useHistory();

    let market = location.pathname.split('/')[1];
    let activeMarket = '';

    useEffect(() => {
        //This alert is only good for Sept. 27th - Oct. 3rd
        const currentDate = new Date().getTime();  // Get the actual current date
        const startDate = new Date('2025-04-03').getTime();  // Define the start date
        const endDate = new Date('2025-06-02').getTime();    // Define the end date
        
        // Check if current date is between startDate and endDate
        if (currentDate >= startDate && currentDate <= endDate) {
            setShowAlert(true);
        }

    }, []);

    const getAllAvailable = () => {

        // ReactGA.event({
        //     category: 'User',
        //     action: 'search_by_available_online',
        //     value: "myitems"
        // });

        const parsedHash = {};
        parsedHash.q = "myitems";
        parsedHash.available=1;
        const stringified = queryString.stringify(parsedHash);
        history.push({
            pathname:  "/search",
            search: stringified,
            state: {
                page: 1
            } 
        });
    }

    if (["marine", "garden", "power-sports"].includes(market)) {
        window.sessionStorage.setItem("lastCategoryPath", market);
    }

    if (window.sessionStorage.getItem("lastCategoryPath") !== null && ["marine", "garden", "power-sports", "detailed-search"].includes(market)) {
        activeMarket = window.sessionStorage.getItem("lastCategoryPath");
    }

    const alertStyles = {
        backgroundColor: '#c71818',
        color: 'white'

    };
    const alertLink = {
        color: 'white'

    };
    const warningStyles = {
        backgroundColor: '#FCD12A',
        color: 'black'

    };
    const warningLink = {
        color: 'black'

    };
    return (
        <div className="menu">
            <div className="container">
                <div className="row">
                    <div className="col-sm-12">
                        <Navbar collapseOnSelect expand="lg">
                            <Navbar.Collapse id="responsive-navbar-nav">
                                <Nav className="mr-auto only-desktop">
                                    {menuDDs.map((menuDD, menuIndex) =>
                                        <MenuDropdown
                                            key={menuIndex}
                                            categoryName={menuDD[0]}
                                            categoryLink={menuDD[1]}
                                            marketId={menuDD[2]}
                                            className={activeMarket === menuDD[1] ? 'active-market' : ''}
                                        />
                                    )}
                                    {/* {loggedUser === true ?
                                    <Nav.Link className="menu-custom" onClick={getAllAvailable}>Available Online</Nav.Link>
                                    : null
                                    } */}
                                </Nav>

                                <Nav>
                                    <MenuSimpleSearch />
                                    {loggedUser === true ?
                                        <Link to="/order/orderCart/0"><ShoppingCartConsumer userToken={userToken}></ShoppingCartConsumer></Link>
                                        : null
                                    }
                                </Nav>
                            </Navbar.Collapse>
                        </Navbar>
                        {ShowAlert ?
                        <div>
                            {/* <Alert variant="danger" onClose={() => setShowAlert(false)} dismissible>
                                <Alert.Link className="row justify-content-center" 
                                href="/newsdocs/InventoryShutdownNotification2024.pdf"
                                target="_blank">Important: Inventory Shutdown Notification - Litchfield</Alert.Link>
                            </Alert> */}
                            <Alert variant="danger" onClose={() => setShowAlert(false)} dismissible>
                                <Alert.Link className="row justify-content-center" 
                                href="/newsdocs/b2b-communication-2025-marketing.pdf"
                                target="_blank">Important notice regarding your access to Catalog.SierraParts.com</Alert.Link>
                            </Alert>
                        </div>
                        : null
                        }
                        {hideDetailedSearch ? null : <MenuDetailedSearch />}

                    </div>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = store => {
    const loggedUser = isLoggedUser(store);
    const userToken = getLoggedUserToken(store);
    return { userToken, loggedUser };
}

export default connect(mapStateToProps)(Menu);